/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { centerSubmitButtonCss } from "./styles";
import { PurposedButtonProps } from "./types";

type Props = PurposedButtonProps & {
  label?: string;
  iconName?: string;
};

const SubmitFormButton = (props: Props) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.save}
      tooltip={props.iconName && formatMessage({ id: "common.save" })}
      iconName={props.iconName}
      label={props.label}
      css={centerSubmitButtonCss}
      dataCy="submit-form-button"
      {...props}
    />
  );
};

export default SubmitFormButton;
